import { ItemResponseRetargetingListBeanObject, ListResponseRetargetingListBean, RetargetingListBean, RetargetingListControllerApi } from 'src/api/api'
import { BaseApi, configuration } from '../../../api/BaseApi'

class RetargetingListApi extends BaseApi {
    api: RetargetingListControllerApi

    constructor() {
        super()
        this.api = new RetargetingListControllerApi(configuration, configuration.basePath, this.fetch)
    }

    list(size: number = 20, page: number = 1, sort, search): Promise<ListResponseRetargetingListBean> {
        return this.call(() => this.api.retargetingLists(search, { query: { size, page, sort } }))
    }

    all(): Promise<ListResponseRetargetingListBean> {
        return this.call(() => this.api.retargetingLists())
    }

    create(retargetingList: RetargetingListBean): Promise<ItemResponseRetargetingListBeanObject> {
        return this.call(() => this.api.createRetargetingList(retargetingList))
    }

    edit(id: any, retargetingList: RetargetingListBean): Promise<ItemResponseRetargetingListBeanObject> {
        return this.call(() => this.api.editRetargetingList(retargetingList, id))
    }

    view(id: any): Promise<ItemResponseRetargetingListBeanObject> {
        return this.call(() => this.api.retargetingList(id))
    }

    delete(id: any): Promise<void> {
        return this.call(() => this.api.deleteRetargetingList(id))
    }
}

const retargetingListApi = new RetargetingListApi()
export default retargetingListApi



// WEBPACK FOOTER //
// ./src/component/app/retargetingList/RetargetingListApi.ts